import {
  AssetResponse,
  DeliveryMethod,
  TrainingAudience,
  TrainingModuleResponse,
} from "../types/training";
import TrainingTouchpoint from "./trainingTouchpoint";

class TrainingModule {
  assets: AssetResponse[];
  audience: TrainingAudience;
  canAccess: boolean;
  canView: boolean;
  deliveryMethod: DeliveryMethod;
  description: string;
  duration: string;
  isReady: boolean;
  languages: string[];
  referenceId: string;
  suggested_order?: number;
  tags: string[];
  title: string;
  touchPoints: TrainingTouchpoint[];
  gradient?: string;

  constructor(parameters: TrainingModuleResponse) {
    this.assets = parameters.assets;
    this.audience = parameters.audience_type;
    this.canAccess = parameters.can_access; // Has the subscription to download scorm files or toolboxes
    this.canView = parameters.can_view; // Has the subscription to view the module and download material
    this.deliveryMethod = parameters.delivery_method;
    this.description = parameters.description;
    this.duration = parameters.duration;
    this.isReady = parameters.is_ready;
    this.languages = parameters.languages;
    this.referenceId = parameters.reference_id;
    this.suggested_order = parameters.suggested_order;
    this.tags = parameters.tags;
    this.title = parameters.title;
    this.touchPoints = parameters.touchpoints
      ?.map((touchPointResponse) => new TrainingTouchpoint(touchPointResponse))
      .sort((a, b) => a.order - b.order);
  }

  isAccessible = () => {
    return this.isReady && this.canView;
  };

  isComingSoon = () => {
    return !this.isReady && this.canView;
  };

  isNotAvailable = () => {
    return !this.canView;
  };

  getAllTouchpointLinks = () => {
    return this.touchPoints.map((tp) => tp.directLink).join("\n");
  };
}

export default TrainingModule;
